export class Channel {
  constructor(
    public name: string = '',
    public config = {},
    public type: ChannelTypeEnum = ChannelTypeEnum.FLAT,
    public id?: string,
  ) {
  }
}

export enum ChannelTypeEnum {
  FLAT = 'FLAT',
  VR = 'VR',
}
